import { handleAdminParentQDDeleted } from "./admin"


export function handleParentQDDeleted(state, patch) {
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminParentQDDeleted(state, payload);
    }

}